/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-06-12 15:11:37
 * @FilePath: \baishu_react_ui\src\Login\BsyAlertTip\Staticize.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import ReactDOM from 'react-dom'
import Dialog from './index'

const tipAlert = props =>
    new Promise((fulfill) => { // 此处参数需用圆括号，否则 eslint 报错
        let holder
        if(document.getElementsByClassName("BsyAlertTip").length>0){
            holder = document.getElementsByClassName("BsyAlertTip")[0]
        }else{
            holder = document.createElement('div');
            holder.classList.add("BsyAlertTip");
            document.body.appendChild(holder)
        }

        let holderTo = document.createElement('div');
        holderTo.classList.add("alertTipContent");
        holder.appendChild(holderTo)

        let timer = setTimeout(()=>{
            holder.removeChild(holderTo)
            ReactDOM.unmountComponentAtNode(holderTo)
            if(document.getElementsByClassName("alertTipContent").length<=0){
                document.body.removeChild(holder)
                ReactDOM.unmountComponentAtNode(holder)
            }
            clearInterval(timer)
        },3000)

        if(document.getElementsByClassName("alertTipContent").length>3){
            holder.removeChild(holderTo)
            ReactDOM.unmountComponentAtNode(holderTo)
            clearInterval(timer)
        }


        ReactDOM.render(
            <Dialog
                {...props}
            />,
            holderTo
        )
    }).catch(res => {
        console.error('tipAlert',res);
    })

export default tipAlert